import React, { useEffect, useState, createRef } from "react";
import { withRouter, Link, useLocation } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import { loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import PatientService from "../services/patient-service";
import facilityService from "../services/facility-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { Multiselect } from "multiselect-react-dropdown";
import { Modal } from "react-responsive-modal";
import { selectUsers } from "../state/reducers/userSlice";
import {
  clearPatId,
  updatePatIdForOrder,
  updatePatIdForRefill,
  getPatId,
  updateOrders,
  clearOrders,
} from "../state/reducers/patientSlice";
import moment from "moment";

const tablePropsInit = {
  columns: [
    { key: "select", title: "Select", style: { width: "100px" } },
    { key: "script_view", title: "Script Details", style: { width: "100px" } },
    { key: "fac_name", title: "facility" },
    { key: "profiled", title: "Status" },
    { key: "rxf_number", title: "Rx" },
    { key: "drg_name", title: "drug" },
    { key: "rxf_sig", title: "sig" },
    { key: "last_fill_date", title: "lastFill" },
    { key: "fil_qty_dsp", title: "Qty" },
    { key: "rxf_ref_left", title: "refillsLeft" },
    { key: "doc_name", title: "doctor" }, 
    { key: "start_date", title: "startDate" },
    { key: "stop_date", title: "stopDate" },
    { key: "shp_date", title: "shipDate" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "userId",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInitInactive = {
  columns: [
    { key: "script_view", title: "Script Details", style: { width: "100px" } },
    { key: "fac_name", title: "facility" },
    { key: "rxf_number", title: "Rx" },
    { key: "rxf_ref_left", title: "refillsLeft" },
    { key: "start_date", title: "startDate" },
    { key: "stop_date", title: "stopDate" },
    { key: "last_fill_date", title: "lastFill" },
    { key: "profiled", title: "Status" },
    { key: "drg_name", title: "drug" },
    { key: "rxf_sig", title: "sig" },
    { key: "doc_name", title: "doctor" },
    { key: "shp_date", title: "shipDate" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "userId",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};

const tablePropsInitOrderDetails = {
  columns: [
    { key: "rx_number", title: "RX" },
    { key: "fac_code", title: "Facility Code" },
    { key: "seq_number", title: "Sequence" },
    { key: "fill_date", title: "Fill Date" },
    { key: "drug", title: "Drug",  style: { width: "200px" }},
    { key: "ship_date", title: "Ship Date" },
    { key: "scanned_user", title: "Scanned User" },
    { key: "actions", title: "Actions" ,style:{ display: "none" }},
    { key: "received_datetime", title: "Received" }
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "rx_number",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 5,
    position: PagingPosition.Bottom,
  },
};
const PatientDetails = ({ history }) => {
  const location = useLocation();
  const state = location.state;

  const [loading, setLoading] = useState(false);
  let { patId } = useSelector(getPatId);
  const { user } = useSelector(selectUsers);
  const dispatch1 = useDispatch();

  const [patientsList, setPatientsList] = useState();
  const [showList, setShowList] = useState("hidden");
  const [patName, setPatName] = useState("");
  const [patDob, setPatDob] = useState("");
  const [patLocation, setPatLocation] = useState("");
  const [patient, setPatient] = useState([]);
  const [patientId, setPatId] = useState("");
  const [tabIndex, setTabIndex] = useState(1);
  const multiselectRef = createRef();
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [tablePropsInactive, changeTablePropsInactive] = useState(tablePropsInitInactive);
  const [tablePropsOrderDetails, changeTablePropsOrderDetails] = useState(tablePropsInitOrderDetails);
  const [orderList, setOrderList] = useState([]);
  const [discontinueOpen, setDiscontinueOpen] = useState(false);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
    }
  };
  const dispatchInactive = async (action) => {
    changeTablePropsInactive((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
    }
  };

  const dispatchOrderDetails = async (action) => {
    changeTablePropsOrderDetails((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
    }
  };
  async function getPatDetails(actnType, selectedPatientDetails) {
    let patDetails =
      multiselectRef.current && multiselectRef.current.getSelectedItems();
    if (actnType === undefined) {
      patDetails = patient?.length > 0 ? patient : patId;
    }

    try {
      setLoading(true);
      let resp = await PatientService.getPatientDrugs(patDetails.length ? patDetails[0].id : selectedPatientDetails[0].id);
      resp.sort(
        (d1, d2) =>
          new Date(d2.start_date).getTime() - new Date(d1.start_date).getTime()
      );
      
      let activeItems = resp?.filter(item => item?.status === 'ACTIVE');
      setOrderList(activeItems);
      dispatch(updateData(activeItems));
      dispatchInactive(updateData(resp?.filter(item => item?.status === 'INACTIVE')));
      setShowList("show");
      if (resp.length > 0) {
        setPatName(resp[0].pat_name);
        setPatId(resp[0].pat_acct_number);
        setPatDob(resp[0].pat_dob);
      } else {
        dispatch(updateData([]));
        dispatchInactive(updateData([]));
        setPatName(
          patDetails[0].name || patId[0]?.lname + ", " + patId[0]?.fname
        );
        setPatId(patDetails[0].accountNumber);
        setPatDob(moment(patDetails[0].dob).format("MM/DD/YYYY"));
      }
      setPatLocation(patDetails?.[0]?.location);
      setLoading(false);
      document.getElementById("search_input").blur();
    } catch (e) {
      setLoading(false);
    }
  }

  const CustomCellNewCheckbox = ({ rowData }) => {
    return (
      <div key={rowData.rowData.rxf_number}>
        <input
          type="checkbox"
          id={rowData.rowData.rxf_number}
          disabled={rowData.rowData.rxf_id === 0} 
          checked={rowData.rowData["selected"]}
          onChange={(e) => {
            const selectedItem = orderList.findIndex(
              (item) => item.rxf_number === rowData.rowData.rxf_number
            );
            orderList[selectedItem]["selected"] = e.target.checked;
            dispatch(updateData(orderList));
          }}
        />
      </div>
    );
  };
const [openPopUp, setOpenPopUp] = useState(false);
const onCloseModal = async()=>{
  setOpenPopUp(false);
  dispatchOrderDetails(updateData([]));
}
  const CustomCellViewScript = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3 cursor-pointer">
          <img
            src="./img/info_icon.svg"
            className="m-auto w-4 h-4"
            onClick={() => {
              handleViewScript(rowData?.rowData?.rxf_id);
            }}
            alt="Script Details"
            title="Script Details"
          />
        </span>
      
      </div>
    );
  };
  const handleViewScript = async (rxf_id) => {
    try {
      setLoading(true);
      const resp = await PatientService.getOrderDetails(rxf_id);
      dispatchOrderDetails(updateData(resp));
      setOpenPopUp(true);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }
  const handleProceed = async () => {
    try {
      setLoading(true);
      var items = orderList.filter((item) => item["selected"] === true);
      dispatch1(updateOrders(items));
      dispatch1(updatePatIdForRefill(patient));
      await history.push("/refill");
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleReleaseMedication = async () => {
    try {
      var items = orderList.filter((item) => item["selected"] === true)
      .map((item) => ({ ...item, pat_id: patient[0].id }));
      
      if (items.length) await history.push("/releaseMedication", items);
      else {
        const { hide } = cogoToast.error("Please Select at least one Medication", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
    } catch (e) {
      setLoading(false);
    }
  };

  const handleRenewMedication = async () => {
    try {
      var items = orderList.filter((item) => item["selected"] === true)
      .map((item) => ({ ...item, pat_id: patient[0].id }));
      
      if (items.length) await history.push("/renewMedication", items);
      else {
        const { hide } = cogoToast.error("Please Select at least one Medication", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
    } catch (e) {
      setLoading(false);
    }
  };

  const handleDiscontinue = async () => {
    try {
      var items = orderList.filter((item) => item["selected"] === true);

      if (items.length !== 0) {
        var list = items?.map((item) => item.rxf_id);
        setLoading(true);
        await PatientService.discontinueOrder(list);
        getPatDetails();
        setLoading(false);
      } else {
        setLoading(false);
        const { hide } = cogoToast.error("No orders selected", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
        return;
      }
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error processing request. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const patients = async () => {
    try {
      setLoading(true);
      let resp = await PatientService.getPatientsList();
      if (resp) {
        let finalArray = resp.map((res) => {
          let patCode = res.acct_number ? " (" + res.acct_number + ")" : "";
          return {
            id: res.id,
            name: res.lname + ", " + res.fname + patCode,
            dob: res.dob,
            location: res.location,
            accountNumber: res.acct_number
          };
        });
        setPatientsList(finalArray);
        if (state && state.pat_id) {
          let selectedPatId = finalArray.filter((item) => item.id === state.pat_id);
          setPatient(selectedPatId);
          getPatDetails(undefined, selectedPatId)
        }
        if (patId?.length > 0) {
          let patSeleted = finalArray.filter((item) => item.id === patId[0].id);
          setPatient(patSeleted);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  useEffect(() => {
    patients();
    getAccessForFacility();
    if (patId?.length > 0) {
      getPatDetails();
    }
    return function cleanup() {
      dispatch1(clearPatId());
    };
  }, []);
  useEffect(() => {
    getAccessForFacility();
  }, [user?.facility]);

  const onDisContinueCloseModal = () => {
    setDiscontinueOpen(false);
  };

  const [access, setAccess] = useState({});
  const getAccessForFacility = async () => {
    try {
      let resp = await facilityService.getAccessForFacilities(user?.facility);
      setAccess(resp);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute ${loading ? "show" : "hidden"
          }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <Modal open={openPopUp} onClose={onCloseModal} center styles={{ modal: { maxWidth: "900px", "overflowy": "scroll" } }}>
        <div className="pt-4 px-4 pb-4 ">
          <h3
            className="text-lg leading-6 font-bold text-lg text-gray-900 pb-2 pl-2"
            id="modal-headline"
          >
            Script Details
          </h3>
          <div className="p-2 text-xs usersList gridList overflow-x-auto">
            <Table
              {...tablePropsOrderDetails}
              childComponents={{
                cellText: {
                  content: (props) => {
                  },
                },
              }}
              dispatch={dispatchOrderDetails}
            />
          </div>
        </div>
      </Modal>
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">PATIENT MEDICATIONS</span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
            <span className="w-3/4 inline-block mr-4 pl-4">
              <Multiselect
                name="patient"
                displayValue="name"
                options={patientsList}
                disable={patientsList?.length === 0}
                ref={multiselectRef}
                closeOnSelect={true}
                selectedValues={patient}
                placeholder="Select Patient"
                onSelect={(selectedList, selectedItem) => {
                  setPatient([selectedItem]);
                  getPatDetails(true);
                  dispatch1(clearPatId());
                  dispatch1(clearOrders());
                }}
                onRemove={(e) => {
                  setShowList("hidden");
                  getPatDetails(false);
                }}
                selectionLimit={1}
              />
            </span>
          </div>
        </div>
        <div className={`py-2 text-xs patientDetails ${showList} flex`}>
          <span className="w-3/4 inline-block">
            <ul>
              <li className="inline-block text-xs leading-6 text-black w-1/4 pl-3">
                <span className="text-xs md:text-base ml-1 font-bold">
                  NAME:
                </span>
                <span className="text-xs md:text-sm ml-1">{patName}</span>
              </li>
              <li className="inline-block text-xs leading-6 text-black w-1/4 pl-3">
                <span className="text-xs md:text-base ml-1 font-bold">
                  DOB:
                </span>
                <span className="text-xs md:text-sm ml-1">{patDob}</span>
              </li>
              {patientId && <li className="inline-block text-xs leading-6 text-black w-1/4 pl-3">
                <span className="text-xs md:text-base ml-1 font-bold">ID:</span>
                <span className="text-xs md:text-sm ml-1">{patientId}</span>
              </li>}
              {patLocation && <li className="inline-block text-xs leading-6 text-black w-1/4 pl-3">
                <span className="text-xs md:text-base ml-1 font-bold">Location:</span>
                <span className="text-xs md:text-sm ml-1">{patLocation}</span>
              </li>}
            </ul>
          </span>
          {access?.new_order === "T" && (  <span className="mr-3 w-1/4 text-right">
            <span onClick={() => dispatch1(updatePatIdForOrder(patient))}>
              <Link
                to="/createOrder"
                className=" bg-header_bg rounded mb-2 py-2 px-2  cursor-pointer text-xs font-bold text-white  inline-block shadow-md leading-6"
              >
                ADD ORDER
              </Link>
            </span>
          </span>)}
        </div>
        <Modal open={discontinueOpen} onClose={onDisContinueCloseModal} center>
          <div className="pt-10 px-8 pb-4 ">
            <h3
              className="text-lg leading-6 font-medium text-gray-900 text-center"
              id="modal-headline"
            >
              Are you sure you want to discontinue?
            </h3>
            <div className="flex justify-center">
              <button
                onClick={() => {
                  handleDiscontinue();
                  setDiscontinueOpen(false);
                }}
                type="button"
                className="mr-4 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setDiscontinueOpen(false);
                }}
                type="button"
                className="rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
        <ul
          className={` p-2  mb-0 flex pt-3  ${showList}`}
          role="tablist"
        >  <li className="mr-2  text-center w-36 cursor-pointer">
            <a
              className={
                "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-36 rounded-t-lg " +
                (tabIndex === 1 ? "text-black bg-header_bg" : "  bg-menu_active")
              }
              onClick={(e) => {
                e.preventDefault();
                setTabIndex(1);
              }}
              data-toggle="tab"
              role="tablist"
            >
              ACTIVE ORDERS
            </a>
          </li>
          <li className="mr-2 flex-auto text-center w-36 cursor-pointer">
            <a
              className={
                "text-xs font-bold uppercase px-2 py-3 shadow-lg  block leading-normal w-36 rounded-t-lg " +
                (tabIndex === 2 ? "text-black bg-header_bg" : "  bg-menu_active")
              }
              onClick={(e) => {
                e.preventDefault();
                setTabIndex(2);
              }}
              data-toggle="tab"
              href="#link2"
              role="tablist"
            >
              INACTIVE ORDERS
            </a>
          </li>
        </ul>
        {tabIndex === 1 && <>
          <div
            className={`p-2 text-xs patientDetails gridList overflow-x-auto  ${showList} `}
          >
            <Table
              className="table-fixed"
              {...tableProps}
              childComponents={{
                cellText: {
                  content: (props) => {
                    // eslint-disable-next-line default-case
                    switch (props.column.key) {
                      case "select":
                        return <CustomCellNewCheckbox rowData={props} />;
                      case "script_view":
                        return <CustomCellViewScript rowData={props} />;
                    }
                  },
                },
              }}
              dispatch={dispatch}
            />
          </div>
          <div
            className={`p-2 text-xs patientDetails gridList overflow-x-auto flex ${showList} `}
          >
            {access?.patient_refill === "T" && (
              <button
                className={
                  orderList?.length === 0
                    ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm mr-4"
                    : "rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm mr-4"
                }
                aria-label="Proceed to Refill"
                onClick={() => handleProceed()}
              >
                Proceed to Refill
              </button>
            )}
            {access?.release_med === "T" && (
              <button
                className={
                  orderList?.length === 0
                    ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-releaseMedication my-3 focus:outline-none text-sm mr-4"
                    : "rounded font-medium h-10 text-white w-full bg-releaseMedication my-3 focus:outline-none text-sm mr-4"
                }
                aria-label="Release Medication"
                onClick={() => handleReleaseMedication()}
              >
                Release Medication
              </button>
            )}
            {access?.renew_order === "T" && (
              <button
                className={
                  orderList?.length === 0
                    ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-renewMedication my-3 focus:outline-none text-sm mr-4"
                    : "rounded font-medium h-10 text-white w-full bg-renewMedication my-3 focus:outline-none text-sm mr-4"
                }
                aria-label="Release Medication"
                onClick={() => handleRenewMedication()}
              >
                Renew Orders
              </button>
            )}
            <button
              className={
                orderList?.length === 0
                  ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-rose my-3 mr-4 focus:outline-none text-sm"
                  : "rounded font-medium h-10 text-white w-full bg-rose my-3 focus:outline-none text-sm"
              }
              aria-label="Discontinue"
              onClick={() => setDiscontinueOpen(true)}
            >
              Discontinue
            </button>
          </div>
        </>

        }
        {tabIndex === 2 && <div
          className={`p-2 text-xs patientDetails gridList overflow-x-auto  ${showList} `}
        >
          <Table
            className="table-fixed"
            {...tablePropsInactive}
            childComponents={{
              cellText: {
                content: (props) => {
                },
              },
            }}
            dispatch={dispatchInactive}
          />
        </div>}
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(PatientDetails)
);
